import { z } from "zod";
export const CrossTenantIncidentSignalV1Schema = z
    .object({
    schemaVersion: z.literal("cross-tenant-incident-signal.v1.0"),
    signalId: z.string().min(1),
    attemptedAgencyId: z.string().min(1),
    boundAgencyId: z.string().min(1),
    route: z.string().min(1),
    detectedAt: z.string().datetime(),
})
    .strict();
export function detectCrossTenantRouteMismatch(input) {
    if (input.attemptedAgencyId === input.boundAgencyId)
        return null;
    return CrossTenantIncidentSignalV1Schema.parse({
        schemaVersion: "cross-tenant-incident-signal.v1.0",
        signalId: `xtenant_${input.attemptedAgencyId}_${input.boundAgencyId}`,
        attemptedAgencyId: input.attemptedAgencyId,
        boundAgencyId: input.boundAgencyId,
        route: input.route,
        detectedAt: input.detectedAt,
    });
}
//# sourceMappingURL=cross-tenant-incident-signal.js.map